import { Controller } from 'stimulus';

/**
 * Attached to each "Total" cell button on the all-orgs billing queue.
 * Bootstrap's data-bs-toggle="modal" opens the shared modal; this controller
 * points the modal's <turbo-frame id="billing_sheet_line_items"> at the right
 * sheet's URL on click. We skip resetting `src` when the requested URL is
 * already loaded so opening the same row twice in a row is instant.
 *
 * The chrome modal-title is generic until a row is clicked — this controller
 * also swaps in the per-row title (org + month) so the header reflects the
 * sheet being viewed before the frame finishes loading.
 */
export default class extends Controller {
  static values = { src: String, title: String };

  load() {
    const frame = document.getElementById('billing_sheet_line_items');
    if (!frame) return;
    if (frame.src !== this.srcValue) {
      frame.src = this.srcValue;
    }
    if (this.hasTitleValue) {
      const titleEl = document.getElementById(
        'billing-sheet-line-items-modal-label'
      );
      if (titleEl) titleEl.textContent = this.titleValue;
    }
  }
}
